import PropTypes from 'prop-types';
import React from 'react';
import { Router, Switch } from 'react-router-dom';

import ClientWebApp from './ClientWebApp';
import cwaRoutes from './cwaRoutes';
import RouteWithSubRoutes from './RouteWithSubRoutes';

export default function ClientWebAppRouter(props) {
  const { clientId, history } = props;

  return (
    <Router history={history}>
      <ClientWebApp showEmptyFallbackUI clientId={clientId}>
        <Switch>
          {cwaRoutes.map(route => (
            <RouteWithSubRoutes
              clientId={clientId}
              key={route.path}
              path={route.path}
              route={route}
            />
          ))}
        </Switch>
      </ClientWebApp>
    </Router>
  );
}

ClientWebAppRouter.propTypes = {
  clientId: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired, // eslint-disable-line
};
